export default "__VITE_ASSET__bf7ade2b__"